<template>
  <div>
    <template v-if="!order_success">
      <v-toolbar>
        <v-toolbar-title>
          <TText value="Order Request Form" />
        </v-toolbar-title>
      </v-toolbar>
      
      <v-card-text>
        <v-form>
          <v-subheader class="title"> <TText value="Order Request Form" /> </v-subheader>
          <v-divider></v-divider>

          <v-subheader class="title"> <TText value="Contact Information" /> </v-subheader>
          <input type="checkbox" id="checkbox" v-model="contact_only">
          <label for="checkbox"> Contact Only </label>
          <DisableableInputField label= "First_Name" :value="order.user.first_name" @change="order.user.first_name = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
          <DisableableInputField label= "Last_Name" :value="order.user.last_name" @change="order.user.last_name = $event" :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
          <DisableableInputField label= "Email" :value="order.user.email" @change="order.user.email = $event" :background_color="'#1d1e20'" align="left" style="margin-top:10px;" />
          <DisableableInputField label= "Phone_number" :value="order.user.phone_number" @change="order.user.phone_number = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
          <template v-if="!contact_only">
          
            <v-divider></v-divider>
          
            <v-subheader class="title"> <TText value="Delivery Address" /> </v-subheader>
            <input type="checkbox" id="checkbox" v-model="invoice_address_same_as_delivery_address">
            <label for="checkbox"> Delivery Address = Invoice Address</label>
            <DisableableInputField label= "Country" :value="order.delivery_address.country" @change="order.delivery_address.country = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
            <DisableableInputField label= "State" :value="order.delivery_address.state" @change="order.delivery_address.state = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
            <DisableableInputField label= "ZIP_Code" :value="order.delivery_address.zip_code" @change="order.delivery_address.zip_code = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
            <DisableableInputField label= "City" :value="order.delivery_address.city" @change="order.delivery_address.city = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
            <DisableableInputField label= "Street" :value="order.delivery_address.street" @change="order.delivery_address.street = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
            <DisableableInputField label= "Building_number" :value="order.delivery_address.building_number" @change="order.delivery_address.building_number = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
            <DisableableInputField label= "Recipient" :value="order.delivery_address.custom_information" @change="order.delivery_address.custom_information = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
            <v-divider></v-divider>

            <template v-if="!invoice_address_same_as_delivery_address">
              <v-subheader class="title"> <TText value="Invoice Address" /> </v-subheader>
              <DisableableInputField label= "Country" :value="order.invoice_address.country" @change="order.invoice_address.country = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
              <DisableableInputField label= "State" :value="order.invoice_address.state" @change="order.invoice_address.state = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
              <DisableableInputField label= "ZIP_Code" :value="order.invoice_address.zip_code" @change="order.invoice_address.zip_code = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
              <DisableableInputField label= "City" :value="order.invoice_address.city" @change="order.invoice_address.city = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
              <DisableableInputField label= "Street" :value="order.invoice_address.street" @change="order.invoice_address.street = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
              <DisableableInputField label= "Building_number" :value="order.invoice_address.building_number" @change="order.invoice_address.building_number = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
              <DisableableInputField label= "Recipient" :value="order.invoice_address.custom_information" @change="order.invoice_address.custom_information = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
              <v-divider></v-divider>
            </template>

          <v-subheader class="title"> <TText value="Items" /> </v-subheader>
          <DisableableInputField label= "Hall_Simulation" :value="order.items.id_1" @change="order.items.id_1 = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
          <DisableableInputField label= "Interior_Simulation" :value="order.items.id_2" @change="order.items.id_2 = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
          <DisableableInputField label= "Lean_Simulation" :value="order.items.id_3" @change="order.items.id_3 = $event"  :background_color="'#1d1e20'" align="left" style="margin-top:10px;"/>
        </template>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-layout column>
          <div>{{ error_message }}</div>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn @click="close()"> <TText value="Cancel" /> </v-btn>
        <v-btn v-if="!isLoading" @click="orderRequest()"><TText value="Send" /></v-btn>
        <LoadingButton v-else></LoadingButton>
      </v-card-actions>
    </template>

    <template v-else>
      <v-toolbar dark>
        <v-toolbar-title>
          <TText value="Order Recieved" />
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text >
        <v-layout column align-center>
          <TText value="Order Recieved" />
          <TIcon name="check-circle" color="green" large />  
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()"><TText value="Close" /></v-btn>
      </v-card-actions>
    </template>
  </div>

</template>

<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';
import validators from '../../helpers/validators'
import LoadingButton from '@/components/UserFeedback/LoadingButton.component.vue'
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'

import {
  mapActions,
  // mapGetters
} from 'vuex';
export default {
  components: {
    LoadingButton,
    DisableableInputField,
    TIcon
  },
  data: () => ({
    rules: {},
    order: {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: ''
      },
      invoice_address:{
        country: '',
        state: '',
        zip_code: '',
        city: '',
        street: '',
        building_number: '',
        custom_information: '',
      },
      delivery_address:{
        country: '',
        state: '',
        zip_code: '',
        city: '',
        street: '',
        building_number: '',
        custom_information: '',
      },
      items:{
        id_1: '0',
        id_2: '0',
        id_3: '0'
      }
    },
    valid: false,
    error_message: '',
    order_success: false,
    isLoading: false,
    invoice_address_same_as_delivery_address: false,
    contact_only: false
  }),
  computed: {
  },
  methods: {
    orderRequest() {
      this.error_message = '';
      this.order_success = false;
      let self = this;

      if (this.invoice_address_same_as_delivery_address){
        this.order.invoice_address = this.order.delivery_address;
      }
      
      if(!this.checkFormData()){
        return;
      }
      this.createUObject({
              call_only: true,
              url: [
                {orders: ''},
                {'show': ''}
              ],
              u_object: {
                name: this.order.user.first_name + ' ' + this.order.user.last_name,
                email: this.order.user.email,
                phone: this.order.user.phone_number,
                contact_only: this.contact_only,
                items: [
                 {"id": "1", "quantity": this.order.items.id_1},
                 {"id": "2", "quantity": this.order.items.id_2},
                 {"id": "3", "quantity": this.order.items.id_3},
                ],
                invoice_address: {
                  country: this.order.invoice_address.country,
                  state: this.order.invoice_address.state,
                  zip_code: this.order.invoice_address.zip_code,
                  city: this.order.invoice_address.city,
                  street: this.order.invoice_address.street,
                  building_number: this.order.invoice_address.building_number,
                  custom_information: this.order.invoice_address.custom_information,
                },
                delivery_address: {
                  country: this.order.delivery_address.country,
                  state: this.order.delivery_address.state,
                  zip_code: this.order.delivery_address.zip_code,
                  city: this.order.delivery_address.city,
                  street: this.order.delivery_address.street,
                  building_number: this.order.delivery_address.building_number,
                  custom_information: this.order.delivery_address.custom_information,
                }
              }
            }).then(function () {
              console.log("Order request success");
              self.order_success = true;
            }).catch(err => {
              console.log("Order request fail");
              this.error_message = err;
            });
    },
    checkFormData() {
      if(!this.order.user.first_name & !this.order.user.last_name){
        this.error_message = "bad name";
        return false
      }
      if(!this.order.user.email | !this.order.user.email.includes("@")| !this.order.user.email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){  
        this.error_message = "bad email";
        return false
      }
      if(!this.order.user.phone_number){
        this.error_message = "bad phone number";
        return false
      }
      if(!this.contact_only){
        if(!this.order.items.id_1 & !this.order.items.id_2 & !this.order.items.id_3){
          this.error_message = "bad items";
          return false
        }
        if(!(this.order.items.id_1 >= 0 & this.order.items.id_2  >= 0 & this.order.items.id_3  >= 0)){
          this.error_message = "bad items";
          return false
        }
        if(this.order.items.id_1 == 0 & this.order.items.id_2  == 0 & this.order.items.id_3  == 0){
          this.error_message = "plase select items";
          return false
        }
        if(!this.checkAddressData(this.order.delivery_address)){
          this.error_message = "bad delivery address";
          return false
        }     
        if(!this.checkAddressData(this.order.invoice_address)){
          this.error_message = "bad invoice address";
          return false
        }
      }
      return true
    },
    checkAddressData(addressData){
      if(!addressData.country){
        return false
      }
      if(!addressData.state){
        return false
      }
      if(!addressData.zip_code){
        return false
      }
      if(!addressData.city){
        return false
      }
      if(!addressData.street){
        return false
      }
      if(!addressData.building_number){
        return false
      }
      if(!addressData.custom_information){
        return false
      }            
      return true
    },
    close() {
      this.setRegisterShow(false);
      var self = this
      setTimeout(function () {
        self.$router.push({
          name: 'Home'
        })
      }, 150);
    },
    ...mapActions('Ultra', [
      'createUObject'
    ]),
    ...mapActions('View', [
      'setRegisterShow'
    ])
  },
  created() {
    this.rules = validators;
  }
}
</script>
